<template>
  <div>
    <div class="container-fluid">
      <!-- end breadcrumb-content -->
      <div class="dashboard-heading mb-5">
        <h3 class="fs-22 font-weight-regular">ارسال دوره</h3>
      </div>
      <form
        method="POST"
        enctype="multipart/form-data"
        v-on:submit="handleCourseSubmit"
      >
        <div class="card card-item">
          <div class="card-body">
            <h3 class="fs-22 font-weight-regular pb-2">اطلاعات پایه</h3>
            <div class="divider"></div>
            <div class="form-row">
              <div class="col-lg-4 form-group">
                <label class="label-text">عنوان دوره</label>
                <input
                  onfocus="this.removeAttribute('readonly');"
                  readonly
                  v-model="course.Name"
                  class="form-control form-control-register pl-3"
                  type="text"
                  placeholder="عنوان دوره را وارد کنید "
                  required
                />
              </div>
              <div class="col-lg-4 form-group">
                <label class="label-text">شناسه دوره</label>
                <input
                  onfocus="this.removeAttribute('readonly');"
                  readonly
                  v-model="course.Uid"
                  class="form-control form-control-register pl-3"
                  type="text"
                  placeholder="شناسه دوره را وارد کنید "
                  required
                />
              </div>
              <div class="col-lg-4 form-group">
                <label class="label-text">دسته بندی</label>
                <Dropdown
                  :loading="false"
                  :filter="true"
                  class="form-control form-control-register primCom"
                  v-model="selectedCat"
                  :options="categories"
                  optionLabel="Category"
                  placeholder="دسته بندی را انتخاب کنید"
                />
              </div>
              <div class="col-lg-4 form-group">
                <label class="label-text"
                  >زمان دوره - {{ formatTime(crsTime) }}</label
                >
                <input
                  onfocus="this.removeAttribute('readonly');"
                  readonly
                  v-model="crsTime"
                  class="form-control form-control-register pl-3"
                  type="text"
                  placeholder="مثلا 30-11 یعنی 11 ساعت و 30 دقیقه"
                  required
                />
              </div>
              <div class="col-lg-4 form-group">
                <label class="label-text">قیمت دوره</label>
                {{ formatPrice(toEngDigit(crsPrice)) }} تومان
                <input
                  v-model="crsPrice"
                  class="form-control form-control-register pl-3"
                  type="number"
                  placeholder="مثلا 7900 تومان"
                  required
                />
                <span class="text-color" v-if="msg.price">{{ msg.price }}</span>
              </div>
              <div class="col-lg-4 form-group">
                <label class="label-text">تخفیف دوره</label>
                {{ formatPrice(toEngDigit(crsDiscount)) }} تومان
                <input
                  v-model="crsDiscount"
                  class="form-control form-control-register pl-3"
                  type="number"
                  placeholder="مثلا 3000 تومان"
                  required
                />
                <span class="text-color" v-if="msg.discount">{{
                  msg.discount
                }}</span>
              </div>

              <div class="col-lg-4 form-group">
                <label class="label-text">زبان دوره</label>
                <Dropdown
                  :loading="false"
                  class="form-control form-control-register primCom"
                  v-model="selectedLang"
                  :options="languages"
                  optionLabel="name"
                  optionValue="code"
                  placeholder="یک مورد را انتخاب کنید"
                />
              </div>
              <div class="col-12"></div>
              <div class="col-lg-6 col-12 form-group mb-0">
                <label class="label-text">تصاویر دوره</label>
                <div class="file-upload-wrap">
                  <input
                    onfocus="this.removeAttribute('readonly');"
                    readonly
                    ref="inputImage"
                    type="file"
                    v-on:change="handleImageUpload($event)"
                    class="file-upload-input"
                  />
                  <span class="file-upload-text"
                    ><i class="la la-cloud-upload mr-2 fs-18"></i>تصاویر را
                    اینجا رها کنید یا برای آپلود کلیک کنید.</span
                  >
                </div>
              </div>
              <div class="col-lg-6 col-12 form-group mb-0">
                <label class="label-text">دموی دوره</label>
                <div class="file-upload-wrap">
                  <input
                    onfocus="this.removeAttribute('readonly');"
                    readonly
                    ref="inputDemo"
                    type="file"
                    v-on:change="handleDemoUpload($event)"
                    class="file-upload-input"
                  />
                  <span class="file-upload-text"
                    ><i class="la la-cloud-upload mr-2 fs-18"></i>فایل دمو را
                    اینجا رها کنید یا برای آپلود کلیک کنید.</span
                  >
                </div>
              </div>
              <div class="col-lg-12 form-group">
                <label class="label-text">شرح دوره</label>
                <CkEditor
                  @sendContent="getContent"
                  :content="initialData"
                ></CkEditor>
              </div>
              <div v-if="working" class="col-lg-12 form-group">
                <label class="label-text">وضعیت بارگذاری دوره</label>
                <ProgressBar
                  :showValue="showProgressValue"
                  :value="progressValue"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="course-submit-btn-box pb-4">
          <button :disabled="working" type="submit" class="btn theme-btn">
            <div v-if="!working">ارسال دوره</div>
            <div v-if="working" class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </button>
        </div>
      </form>
    </div>
  </div>
  <Toast position="top-left" />
</template>

<script>
import axios from "axios";
import ls from "localstorage-slim";
import CkEditor from "../components/CkEditor.vue";
import { languages } from "../constants";

export default {
  name: "SaveCourse",
  components: {
    CkEditor,
  },
  data() {
    return {
      initialData: "",
      ckContent: "",
      crsTime: "",
      crsPrice: "",
      crsDiscount: "",
      submitted: false,
      course: {},
      me: {},
      working: false,
      msg: [],
      pleaseChoose: "لطفا انتخاب کنید",
      progressValue: 0,
      showProgressValue: true,
      file: "",
      images: "",
      demo: "",
      categories: [],
      languages: languages,
      selectedCat: {},
      selectedLang: -1,
    };
  },
  watch: {
    crsPrice(value) {
      this.crsPrice = value;
      this.validateFields(value, 0);
    },
    crsDiscount(value) {
      this.crsDiscount = value;
      this.validateFields(value, 1);
    },
    selectedLang(value) {
      this.selectedLang = value;
      this.validateFields(value, 2);
    },
    selectedCat(value) {
      this.selectedCat = value;
    },
  },
  methods: {
    getContent(event) {
      this.ckContent = event;
    },

    getCredentials() {
      this.me = JSON.parse(ls.get("user"));
      this.getCategories();
    },
    validateFields(value, i) {
      switch (i) {
        case 0:
          var regex = new RegExp("^[0-9]+$");
          var result = regex.test(value);
          if (!result && value.length > 0) {
            this.msg["price"] = "لطفا قیمت را صحیح وارد کنید";
          } else {
            this.msg["price"] = "";
          }
          break;
        case 1:
          var regex = new RegExp("^[0-9]+$");
          var result = regex.test(value);
          if (!result && value.length > 0) {
            this.msg["dicsount"] = "لطفا تخفیف را صحیح وارد کنید";
          } else {
            this.msg["dicsount"] = "";
          }
          break;
        case 2:
          if (value === this.pleaseChoose) {
            this.msg["lang"] = "لطفا زبانی را وارد کنید";
          } else {
            this.msg["lang"] = "";
          }
          break;
        case 3:
          if (value === this.pleaseChoose) {
            this.msg["cat"] = "لطفا دسته بندی را وارد کنید";
          } else {
            this.msg["cat"] = "";
          }
          break;
        case 4:
          if (value === this.pleaseChoose) {
            this.msg["teacher"] = "لطفا استادی را وارد کنید";
          } else {
            this.msg["teacher"] = "";
          }
          break;

        default:
          break;
      }
    },
    async handleCourseSubmit(e) {
      e.preventDefault();
      this.working = true;
      if (this.formatTime(this.crsTime) === -1) {
        this.$toast.add({
          severity: "error",
          summary: "خطا در ثبت",
          detail: "لطفا زمان دوره را درست وارد کنید",
          life: 5000,
        });
        this.working = false;
        return;
      }
      if (parseInt(this.crsDiscount) > parseInt(this.crsPrice)) {
        this.$toast.add({
          severity: "error",
          summary: "خطا در ثبت",
          detail: "تخفیف دوره نمی تواند از قیمت دوره بیشتر باشد",
          life: 5000,
        });
        this.working = false;
        return;
      }
      if (this.crsPrice < this.crsDiscount) {
        this.$toast.add({
          severity: "error",
          summary: "خطا در ثبت",
          detail: "قیمت دوره نمی تواند از تخفیف دوره کمتر باشد",
          life: 5000,
        });
        this.working = false;
        return;
      }
      if (
        this.selectedCat === {} ||
        this.selectedLang === -1 ||
        this.msg.length !== 0
      ) {
        this.$toast.add({
          severity: "error",
          summary: "خطا در ثبت",
          detail:
            "همه موارد را ثبت کنید یا لطفا خطاهای نشان داده شده را برطرف کنید",
          life: 5000,
        });
        this.working = false;
        return;
      }
      this.submitted = true;
      let formData = new FormData();

      formData.append("name", this.course.Name);
      formData.append("uid", this.course.Uid);

      formData.append("image", this.images[0]);
      formData.append("techid", this.me.Id);
      formData.append("catid", this.selectedCat.Id);
      formData.append("category", this.selectedCat.Category);
      formData.append("demo", this.demo[0]);

      formData.append("status", 1);
      formData.append("disc", this.ckContent);
      formData.append("price", this.crsPrice);
      formData.append("discount", this.crsDiscount);
      formData.append("lang", this.selectedLang);
      formData.append("time", this.crsTime);

      await axios
        .post("/api/v1/teacher/course/save/spot", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: function (progressEvent) {
            this.progressValue = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
        .then((response) => {
          if (response.status == 200) {
            this.working = false;
            this.$toast.add({
              severity: "success",
              summary: "دوره با موفقیت ثبت شد",
              life: 5000,
            });
            this.files = "";
            this.images = "";
            this.demo = "";
            this.crsTime = "";
            this.crsPrice = "";
            this.crsDiscount = "";
            this.course.Name = "";
            this.course.Uid = "";
            this.submitted = false;
            this.selectedCat = -1;
            this.selectedLang = -1;
            this.initialData = "";
            this.$refs.inputDemo.value = null;
            this.$refs.inputImage.value = null;
            this.working = false;
          } else {
            this.working = false;

            this.$toast.add({
              severity: "error",
              summary: "لطفا مجدد تلاش کنید یا خطاها زا برطرف کنید",
              life: 5000,
            });
          }
        });
    },
    handleDemoUpload(event) {
      if (event.target.files[0].size > 50000000) {
        this.$toast.add({
          severity: "error",
          summary: "فایل انتخابی نباید بیش از 50 مگابایت باشد",
          life: 5000,
        });
        return;
      }
      this.demo = event.target.files;
    },
    handleImageUpload(event) {
      if (event.target.files[0].size > 1000000) {
        this.$toast.add({
          severity: "error",
          summary: "فایل انتخابی نباید بیش از 1 مگابایت باشد",
          life: 5000,
        });
        return;
      }
      this.images = event.target.files;
    },
    async getCategories() {
      var response = await axios.get("/api/v1/teacher/course/category");
      this.categories = response.data;
    },
  },
  mounted() {
    this.getCredentials();
  },
};
</script>

<style></style>
